import React from 'react';
import VerticalField from '../VerticalField';
import FieldLabel from '../FieldLabel';
import FieldError from '../FieldError';
import InputField from '../InputField';

// Complete input field prepared for names with length and duplicate errors

interface IProps {
  label: string;
  value: string;
  targetErrorElement: string;
  maxLength?: number;
  placeholder?: string;
  onChange?: (value: string) => void;
  hasError?: boolean;
  isDuplicate?: boolean;
  error?: string;
  disabled?: boolean;
  noMargin?: boolean;
}

export default ({
  label,
  value,
  targetErrorElement,
  maxLength,
  placeholder,
  onChange,
  hasError,
  isDuplicate,
  error,
  disabled,
  noMargin,
}: IProps) => {
  const maxLengthExceeded = maxLength && value.trim().length > maxLength;
  const isInvalid =
    isDuplicate || maxLengthExceeded || hasError || Boolean(error);

  return (
    <VerticalField noMargin={noMargin}>
      <FieldLabel>{label}</FieldLabel>
      <InputField
        autoComplete="off"
        name="search"
        value={value}
        onChange={onChange}
        placeholder={placeholder || 'Add name'}
        hasError={isInvalid}
        disabled={disabled}
      />
      {maxLengthExceeded && (
        <FieldError
          type="length"
          targetElement={targetErrorElement}
          maxLength={maxLength}
        />
      )}
      {isDuplicate && (
        <FieldError
          type="duplicate"
          targetElement={targetErrorElement}
          name={value.trim()}
        />
      )}
      {error && <FieldError type="custom" customError={error} />}
    </VerticalField>
  );
};
